/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Invite_CountInputs */

const en_us2_invite_count = /** @type {(inputs: Invite_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`People who joined with your invite: ${i?.count}`)
};

const pt_br2_invite_count = /** @type {(inputs: Invite_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pessoas que entraram com seu convite: ${i?.count}`)
};

const pt_pt2_invite_count = /** @type {(inputs: Invite_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pessoas que entraram com seu convite: ${i?.count}`)
};

/** @type {(inputs: Invite_CountInputs) => LocalizedString} */
const es_419_invite_count = en_us2_invite_count;

/** @type {(inputs: Invite_CountInputs) => LocalizedString} */
const fr_fr2_invite_count = en_us2_invite_count;

/** @type {(inputs: Invite_CountInputs) => LocalizedString} */
const de_de2_invite_count = en_us2_invite_count;

/** @type {(inputs: Invite_CountInputs) => LocalizedString} */
const it_it2_invite_count = en_us2_invite_count;

/**
* | output |
* | --- |
* | "People who joined with your invite: {count}" |
*
* @param {Invite_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_count = /** @type {((inputs: Invite_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_count(inputs)
	if (locale === "es-419") return es_419_invite_count(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_count(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_count(inputs)
	if (locale === "de-DE") return de_de2_invite_count(inputs)
	if (locale === "it-IT") return it_it2_invite_count(inputs)
	return en_us2_invite_count(inputs)
});
export { invite_count as "invite.count" }